<template>
    <div :class="['metric-card', 'card', { compact, 'use-gradient': useGradient }]">
        <div class="card-header" @click="toggleSparklineHandler" :style="toggleSparkline ? 'cursor: pointer;' : ''">
            <h4>
                {{ title }}<span v-if="toggleSparkline"
                                 :class="{'caret-icon small text-success': true, 'rotated': localSparkline*.5}">
          ▼
        </span>
            </h4>

            <small>{{ subtitle }}</small>
        </div>
        <div class="card-body">
            <div class="metric-value">
                {{
                    typeof metric === 'number' ? metric.toLocaleString(undefined, {
                        notation: 'compact',
                        maximumSignificantDigits: sigFigs
                    }) : metric
                }} <span v-if="unit">{{ unit }}</span>
            </div>

        </div>
        <div v-if="displaySparkline">
            <component :is="sparklineComponent" :data="sparklineData"
                       :suffix="unit"
                       :legend="false" :stacked="stacked" :labels="[]"
                       :colors="chartColors"
                       :library=" { scales: { y: {  border: { display:false,}, grid: {display:false}, ticks: { display: false }}, x: {  border: { display:false,}, grid: {display:false}, ticks: { display: false } } } }"
                       height="240"
            ></component>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "MetricCard",
    props: {
        title: {type: String, default: ""},
        subtitle: {type: String, default: ""},
        apiUrl: {type: String, required: true},
        sigFigs: {type: Number, default: 3},
        refreshInterval: {type: Number, default: 10000},
        fixedMetric: {type: Number, default: null},
        unit: {type: String, default: ""},
        chartColors: {default: window.divergentColor},
        responseName: {type: String, default: ""},
        showSparkline: {type: Boolean, default: false},
        stacked: {type: Boolean, default: false},
        sparklineComponent: {type: String, default: 'line-chart'},
        compact: {type: Boolean, default: false},
        useGradient: {type: Boolean, default: false},
        toggleSparkline: {type: Boolean, default: true}
    },
    data() {
        return {
            metric: null,
            sparklineData: [],
            localSparkline: false
        };
    },
    computed: {
        displaySparkline() {
            return this.toggleSparkline ? this.localSparkline : this.showSparkline;
        }
    },
    methods: {
        toggleSparklineHandler() {
            if (this.toggleSparkline) {
                this.localSparkline = !this.localSparkline;
            }
        },
        fetchData() {
            axios.get(this.apiUrl).then(res => {
                if (!Array.isArray(res.data)) res.data = [res.data];
                if (Array.isArray(res.data) && res.data.length) {
                    // filter to where obj.name == responseName
                    res.data.filter(obj => {
                        if (this.$props.stacked) {
                            // combine all the latest values
                            var met = 0;
                            res.data.forEach(obj => {
                                met += obj.data["2 mins ago"];
                            })
                            this.metric = met
                            this.sparklineData = res.data
                        } else {
                            if (String(obj.name).toLowerCase() == String(this.responseName).toLowerCase()) {
                                var last = null
                                Object.keys(obj.data).forEach((item, index) => {
                                    last = obj.data[item];
                                });
                                this.metric = last;
                                this.sparklineData = obj.data;

                            }
                        }
                    });
                    // this.metric = res.data[res.data.length - 1];
                    // this.sparklineData = res.data;
                } else if (res.data.value !== undefined) {
                    this.metric = res.data.value;
                }
            });
        }
    },
    mounted() {
        this.localSparkline = this.showSparkline;
        if (!this.fixedMetric) {
            this.fetchData();
            setInterval(this.fetchData, this.refreshInterval);
        } else {
            this.metric = this.fixedMetric;
        }
    }
};
</script>

<style scoped>
.metric-card {
    margin-bottom: 1rem;
    padding: 0.5rem;
    border-radius: 6px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.metric-card.use-gradient {
    background: linear-gradient(135deg, #9945ff, #14f195);
    color: #fff;
}

.metric-card:not(.use-gradient) {
    background: #f8f9fa;
    color: #333;
}

.metric-card.compact {
    padding: 0rem;

}

.compact .card-header {
    padding: 0.5rem;
    border-bottom: 1px solid #e9ecef;
}

.compact .card-body {
    padding: 0.5rem;

}

.compact h4 {
    font-size: .9rem
}

.compact .metric-value {
    font-size: 1.25rem;
    font-weight: 500;
}

.metric-value {
    font-size: 1.5rem;
    font-weight: bold;
}

.caret-icon {
    display: inline-block;
    margin-left: 0.5rem;
    transition: transform 0.2s ease;
}

.rotated {
    transform: rotate(180deg);
}
</style>
